<template>
  <div>
    <van-nav-bar title="离开本市申请" left-text="返回" right-text="" @click-left="onClickLeft"/>
    <van-collapse v-model="activeNames">
      <van-collapse-item title="离开本市说明" name="1" icon="calendar-o">
        <div style="color: red" v-html="this.tips"></div>
      </van-collapse-item>
    </van-collapse>
    <van-form class="login-form-top">

      <van-field name="radio" label="申请类型">
        <template slot="input">
          <van-radio-group v-model="applyType" direction="horizontal">
            <van-radio :name="item.value" v-for="item in applyTypeList" :key="item.value">
              {{ item.label }}
            </van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <van-field
        readonly
        clickable
        name="startDate"
        :value="startDate"
        label="开始时间"
        placeholder="点击选择日期"
        :rules="[{ required: true, message: '请选择开始时间' }]"
        @click="showBeginCalendar = true"
      />
      <van-calendar :show-confirm="false" v-model="showBeginCalendar" @confirm="onBeginConfirm"
                    :min-date="minDate" :max-date="maxDate"/>
      <van-field
        readonly
        clickable
        name="endDate"
        :value="endDate"
        label="结束时间"
        placeholder="点击选择日期"
        :rules="[{ required: true, message: '请选择结束时间' }]"
        @click="showEndCalendar = true"
      />
      <van-calendar :show-confirm="false" v-model="showEndCalendar" @confirm="onEndConfirm"
                    :min-date="minDate" :max-date="maxDate"/>
      <van-field
        v-model="city"
        name="city"
        label="目的地"
        placeholder="目的地"
        :rules="[{ required: true, message: '请填写目的地' }]"
      />
<!--      <van-field-->
<!--        readonly-->
<!--        clickable-->
<!--        :value="provinceName"-->
<!--        name="province"-->
<!--        label="目的地省份"-->
<!--        placeholder="点击选择目的地省份"-->
<!--        @click="provinceShow = true"-->
<!--        :rules="[{ required: true, message: '请选择目的地省份' }]"-->
<!--      />-->
<!--      <van-action-sheet v-model="provinceShow" :actions="provinceList" @select="provinceClick"/>-->
<!--      <van-field-->
<!--        readonly-->
<!--        clickable-->
<!--        :value="cityName"-->
<!--        name="city"-->
<!--        label="目的地城市"-->
<!--        placeholder="点击选择目的地城市"-->
<!--        @click="cityShow = true"-->
<!--        :rules="[{ required: true, message: '请选择目的地城市' }]"-->
<!--      />-->
<!--      <van-action-sheet v-model="cityShow" :actions="cityList" @select="cityClick"/>-->
      <van-field
        v-model="reason"
        rows="3"
        autosize
        label="原因"
        type="textarea"
        maxlength="50"
        placeholder="请填写原因"
        show-word-limit
      />
      <van-field name="applyFile" label="附件">
        <template slot="input">
          <van-uploader :before-read="beforeApplyFileRead" :after-read="afterApplyFileRead"
                        :max-size="5000 * 1024" max-count="6" v-model="showFiles" multiple
                        :before-delete="beforeApplyFileDelete"
                        accept="image/*,.pdf,.doc,.docx,.xml,.dwg,.ppt,.pptx,.txt,.xls,.xlsx,.zip,.rar">
          </van-uploader>
        </template>
      </van-field>

    </van-form>
<!--    <div style="margin: 16px;">-->
<!--      <van-button round block type="primary" native-type="submit" @click="taskSave">保存</van-button>-->
<!--    </div>-->
    <div style="margin: 16px;">
      <van-button round block type="info" native-type="submit" @click="taskSubmit">提交</van-button>
    </div>

    <van-dialog v-model="roleShow" title="我的角色" show-cancel-button @confirm="roleCommit" confirmButtonText="提交">
      <van-radio-group v-model="roleRadio">
        <van-cell-group>
          <van-cell :title="item.roleName" clickable v-for="item in roleList" :key="item.roleAlias"
                    clickable @click="roleRadio = item.roleAlias">
            <template slot="right-icon">
              <van-radio :name="item.roleAlias"></van-radio>
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-dialog>
    <ProcessDialog ref="showProcessDialog" :submitFlowMethod="submitFlowMethod"
                   :getFlowParamsMethod="getFlowParamsMethod"/>
  </div>
</template>

<script>

import {Dialog, Toast} from "vant";
import Vue from "vue";
import moment from "moment";
import {isLogin, isWechat, replaceUrl} from "../../../utils/util";

export default {
  name: "workOverTimeForm",
  data() {
    return {
      activeNames: ['1'],
      taskId: '',
      processInstanceId: '',
      processDefinitionId: '',
      appNo: '',
      province: '',
      provinceName: '',
      provinceList: [],
      provinceShow: false,
      city: '',
      cityName: '',
      cityList: [],
      cityShow: false,
      applyTypeList: [{
        label: '因公',
        value: "0"
      }, {
        label: '因私',
        value: "1"
      }],
      applyType: '0',
      showBeginCalendar: false,
      startDate: '',
      showEndCalendar: false,
      endDate: '',
      realName: '',
      deptName: '',
      userInfo: {},
      userOutCityId: 0,
      choseRoleId: '',
      nextProcess: false,
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(2099, 0, 31),
      trafficDay: 0,
      destination: '',
      reason: '',
      showFiles: [],
      allFiles: {
        applyFiles: [],
        removedFiles: [],
      },
      applyFileIds: [],
      workYear: 0,
      roleShow: false,
      roleRadio: 0,
      roleList: [],
      pageType: 0,
      processShow: false,
      tips: '',
      modelKey: "UserOutCity",
      userOutCityForm: {},
    };
  },
  mounted() {
    if(!isLogin()){
      this.$router.push({
        path: "/attenceflow/Error",
        query: {
        }
      });
    }
    this.appNo = this.$route.query.appNo;
    this.processInstanceId = this.$route.query.processInstanceId;
    this.taskId = this.$route.query.taskId;
    this.processDefinitionId = this.$route.query.processDefinitionId;
    this.userOutCityId = this.$route.query.userOutCityId;
    this.pageType = this.$route.query.pageType;
    this.initUserInfo();
  },
  methods: {
    initUserInfo() {
      this.getUserInfo();
    },
    getUserInfo() {
      this.$fetch("/attence-api/blade-user/info", {}).then(
        res => {
          const user = res.data;
          this.realName = user.realName;
          this.deptName = user.deptName;
          this.userInfo = user;
          this.workYear = user.workYear;
          this.dictionaryInit();
        }
      );
    },
    provinceClick(item) {
      this.provinceShow = false;
      this.province = item.provinceCode;
      this.provinceName = item.provinceName;
      this.city = '';
      this.cityName = '';
      this.$fetch("/attence-api/blade-system/region/select", {
        code: item.provinceCode
      }).then(res => {
        const data = res.data;
        this.cityList = data;
      });
    },
    cityClick(item) {
      if (this.province == '') {
        Toast("请先选择目的地省份");
        return;
      }
      this.cityShow = false;
      this.city = item.cityCode;
      this.cityName = item.cityName;
    },
    //获取基础数据 当前登陆人员加班编号等
    getInitData() {
      //如果当前流程已数据
      this.$fetch("/attence-api/blade-flow/process/userOutCity/flowDetailByFlowAppNo", {
        flowAppNo: this.appNo,
      }).then(res => {
        const data = res.data;
        if (data.id != undefined) {
          this.userOutCityId = data.id;
          this.startDate = data.startDate;
          this.endDate = data.endDate;
          this.applyType = data.applyType;
          this.province = data.province;
          this.provinceName = data.provinceName;
          this.city = data.city;
          this.cityName = data.cityName;
          this.reason = data.reason;
          this.allFiles = data.allFiles;
          this.showFiles = data.allFiles.applyFiles;
          this.showFiles.forEach(v => {
            this.applyFileIds.push(v.id);
            v.url = replaceUrl(v.viewUrl);
          });
          this.userOutCityForm = data;
        }
      });
    },
    dictionaryInit() {
      this.$fetch("/attence-api/blade-system/region/select", {
        code: '00'
      }).then(res => {
        const data = res.data;
        this.provinceList = data;
        this.getInitData();
      });
      this.$fetch("/attence-api/blade-system/param/getSystemParam", {
        key: 'USER_OUT_CITY_PROMPT'
      }).then(res => {
        const data = res.data;
        if (data != null) {
          this.tips = data;
        }
      });
    },
    onBeginConfirm(date) {
      this.startDate = moment(date).format("YYYY-MM-DD");
      this.endDate = '';
      this.showBeginCalendar = false;
    },
    onEndConfirm(date) {
      if (this.startDate == '') {
        Toast('请先选择开始时间');
      } else {
        if (date.getTime() >= Date.parse(this.startDate.replace(/\-/g, '/') + ' 00:00:00')) {
          this.endDate = moment(date).format("YYYY-MM-DD");
        } else {
          this.endDate = '';
          Toast('结束时间必须大于等于开始时间');
        }
      }

      this.showEndCalendar = false;
    },
    onClickLeft: function () {
      let path = '';
      if (this.pageType == 0) {
        path = '/attenceflow/FlowList';
      } else {
        path = '/attenceflow/userOutCity/list';
      }
      this.$router.push({
        path: path,
        query: {}
      });
    },
    // 返回布尔值
    beforeApplyFileRead(file) {
      return true;
    },
    afterApplyFileRead(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      // 此时可以自行将文件上传至服务器
      console.log(file);
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('bizColumn', 'applyFiles');
      this.$filePost("/attence-api/blade-manager/bizAttach/upload", formData).then(
        res => {
          const data = res.data;
          file.status = 'done';
          file.message = '上传成功';
          this.applyFileIds.push(data.id);
          this.allFiles.applyFiles.push(data);
          console.log("IDS：" + JSON.stringify(data));
        },
        error => {
          file.status = 'failed';
          file.message = '上传失败';
        }
      );
    },
    beforeApplyFileDelete(file, detail) {
      let index = JSON.stringify(detail.index);
      let delId = this.applyFileIds[index];
      let url = "/attence-api/blade-manager/bizAttach/remove";
      this.$post(url, {
        ids: delId,
      }).then(
        res => {
          const data = res.data;
          this.applyFileIds.splice(index, 1);
          Toast('刪除成功');
          console.log("IDS：" + this.applyFileIds);
        },
        error => {
        }
      );
      return true;
    },
    taskSave() {
      // if (this.province == '') {
      //   Toast('请选择目的地省份');
      //   return;
      // }

      if (this.city == '') {
        Toast('请填写目的地');
        return;
      }

      if (this.beginTime == '' || this.endTime == '') {
        Toast('请选择离开时间');
        return;
      }

      if (this.reason == '') {
        Toast('请填写原因');
        return;
      }


      const params = {
        id: this.userOutCityId,
        startDate: this.startDate,
        endDate: this.endDate,
        reason: this.reason,
        applyType: this.applyType,
        province: this.province,
        city: this.city,
        allFiles: this.allFiles,
        flowAppNo: this.appNo,
        processInstanceId: this.processInstanceId,
        processDefinitionId: this.processDefinitionId,
      };
      this.userOutCityForm.id = this.userOutCityId;
      this.userOutCityForm.startDate = this.startDate;
      this.userOutCityForm.endDate = this.endDate;
      this.userOutCityForm.reason = this.reason;
      this.userOutCityForm.applyType = this.applyType;
      this.userOutCityForm.province = this.province;
      this.userOutCityForm.city = this.city;
      this.userOutCityForm.allFiles = this.allFiles;
      this.userOutCityForm.flowAppNo = this.appNo;
      this.userOutCityForm.processInstanceId = this.processInstanceId;
      this.userOutCityForm.processDefinitionId = this.processDefinitionId;

      //流程参数
      this.userOutCityForm.flow = {
        taskId: this.taskId,
        processInstanceId: this.processInstanceId,
        processDefinitionId: this.processDefinitionId,
        variables: {
          notifyUserIds:"",
          showNextUserTasks:"true",
        },
      };
      this.userOutCityForm.selectedRole = this.choseRoleId;
      this.$bodyPost("/attence-api/blade-flow/process/userOutCity/submit", this.userOutCityForm).then(resp => {
        Toast("数据保存成功");
        this.$router.push({
          path: "/attenceflow/userOutCity/list",
          query: {}
        });
      }, error => {

      });
    },
    taskSubmit() {
      // if (this.province == '') {
      //   Toast('请选择目的地省份');
      //   return;
      // }

      if (this.city == '') {
        Toast('请选择目的地城市');
        return;
      }

      if (this.beginTime == '' || this.endTime == '') {
        Toast('请选择离开时间');
        return;
      }

      if (this.reason == '') {
        Toast('请填写原因');
        return;
      }

      this.$fetch("/attence-api/blade-user/getUserFlowRoleList", {}).then(res => {
        const data = res.data;
        this.roleList = [];
        data.forEach((v) => {
          if (v.roleFlow != undefined && v.roleFlow != "") {
            const flowLit = v.roleFlow.split("|");
            flowLit.forEach((flow) => {
              if (this.modelKey == flow) {
                this.roleList.push(v);
              }
            });
          }
        });
        if (this.roleList.length > 0) {
          if (this.roleList.length > 1) {//流程发起角色大于1个选择角色发起流程
            this.roleRadio = this.roleList[0].roleAlias;
            this.choseRoleId = this.roleList[0].roleAlias;
            this.roleShow = true;
          } else {
            this.choseRoleId = this.roleList[0].roleAlias;
            this.showProcessInfo();
          }
        } else {
          Toast('未配置流程发起角色，请联系统系管理员！');
        }
      });
    },
    roleCommit() {
      this.choseRoleId = this.roleRadio;
      this.showProcessInfo();
    },
    choseRoleSubmit() {
      const params = {
        id: this.userOutCityId,
        startDate: this.startDate,
        endDate: this.endDate,
        reason: this.reason,
        applyType: this.applyType,
        province: this.province,
        city: this.city,
        allFiles: this.allFiles,
        flowAppNo: this.appNo,
        processInstanceId: this.processInstanceId,
        processDefinitionId: this.processDefinitionId,
      };
      this.userOutCityForm.id = this.userOutCityId;
      this.userOutCityForm.startDate = this.startDate;
      this.userOutCityForm.endDate = this.endDate;
      this.userOutCityForm.reason = this.reason;
      this.userOutCityForm.applyType = this.applyType;
      this.userOutCityForm.province = this.province;
      this.userOutCityForm.city = this.city;
      this.userOutCityForm.allFiles = this.allFiles;
      this.userOutCityForm.flowAppNo = this.appNo;
      this.userOutCityForm.processInstanceId = this.processInstanceId;
      this.userOutCityForm.processDefinitionId = this.processDefinitionId;
      //流程参数
      this.userOutCityForm.flow = {
        taskId: this.taskId,
        processInstanceId: this.processInstanceId,
        processDefinitionId: this.processDefinitionId,
        variables: {
          notifyUserIds:"",
          showNextUserTasks:"true",
        },
      };
      this.userOutCityForm.selectedRole = this.choseRoleId;
      this.$bodyPost("/attence-api/blade-flow/process/userOutCity/start-process", this.userOutCityForm).then(resp => {
        const data = resp.data;
        Toast('流程提交成功');
        this.roleShow = false;
        this.processShow = true;
        this.jumpPage();
      });
    },
    jumpPage() {
      let path = '';
      if (this.pageType == 0) {
        path = '/attenceflow/FlowList';
      } else {
        path = '/attenceflow/userOutCity/list';
      }
      this.$router.push({
        path: path,
        query: {}
      });
    },
    showProcessInfo() {
      //展示对话框
      this.$refs.showProcessDialog.showProcessInfo();
      this.roleShow = false;
    },
    submitFlowMethod() {
      this.choseRoleSubmit();
    },
    getFlowParamsMethod() {
      //用于对话框展示请求接口参数
      let a1 = Date.parse(this.startDate);
      let a2 = Date.parse(this.endDate);
      let days = parseInt((a2 - a1) / (1000 * 60 * 60 * 24));
      debugger
      const params = {
        businessId: this.userOutCityId,
        taskId: this.taskId,
        processInstanceId: this.processInstanceId,
        flag: 'ok',
        processDefinitionKey: this.modelKey,
        variables: {
          outDays: days + 1,
          roleType: this.choseRoleId,
          auditStatus: " ",
        },
      };

      return params;
    },
  }
}
</script>

<style scoped>
.van-nav-bar {
  background-color: #2196f3;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

/deep/ .van-nav-bar__text {
  color: #fff;
}

.login-form-top {
  margin-top: 0px;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/attenceflow/userOutCity/form.vue